import register from '@kpsys/angularjs-register';
import localizationRoutes from './localizations.routes';
import LocalizationsDataService from './localizations-data.service';
import LocalizationsService from './localizations.service';
import {KpLocalizationsService} from './kp-localizations.service';

export default register('portaro.features.localizations')
    .config(localizationRoutes)
    .service(LocalizationsDataService.serviceName, LocalizationsDataService)
    .service(LocalizationsService.serviceName, LocalizationsService)
    .service(KpLocalizationsService.serviceName, KpLocalizationsService)
    .name();